<template>
  <div class="pulse">
    <div class="pulse__tile">
      <div class="pulse__num pulse__num--brand">{{ unanswered }}</div>
      <div class="pulse__lbl">Sin responder</div>
    </div>
    <div class="pulse__tile">
      <div class="pulse__num">{{ p.newThisWeek }}</div>
      <div class="pulse__lbl">Nuevas (7d)</div>
      <div class="pulse__delta" :class="deltaClass">{{ deltaLabel }}</div>
    </div>
    <div class="pulse__tile">
      <div class="pulse__num">{{ p.inProgress }}</div>
      <div class="pulse__lbl">En gestión</div>
    </div>
    <div class="pulse__tile">
      <div class="pulse__num pulse__num--won">{{ p.wonThisMonth }}</div>
      <div class="pulse__lbl">Ganadas (30d)</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pulse: { type: Object, default: () => ({}) },
    unanswered: { type: Number, default: 0 }
  },
  computed: {
    p() {
      return this.pulse || {};
    },
    delta() {
      return (this.p.newThisWeek || 0) - (this.p.newPrevWeek || 0);
    },
    deltaLabel() {
      if (!this.p.newPrevWeek && !this.p.newThisWeek) return "—";
      const d = this.delta;
      const arrow = d > 0 ? "↑" : d < 0 ? "↓" : "→";
      return `${arrow} ${Math.abs(d)} vs. semana previa`;
    },
    deltaClass() {
      return this.delta > 0 ? "pulse__delta--up" : this.delta < 0 ? "pulse__delta--down" : "";
    }
  }
};
</script>

<style scoped>
.pulse { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 22px; }
@media (max-width: 720px) { .pulse { grid-template-columns: repeat(2, 1fr); } }
.pulse__tile {
  background: #fff; border: 1px solid #ece7de; border-radius: 14px; padding: 16px 18px;
  box-shadow: 0 8px 24px -16px rgba(40, 33, 22, 0.18);
}
.pulse__num { font-size: 28px; font-weight: 700; color: #1a1814; line-height: 1; }
.pulse__num--brand { color: #b52118; }
.pulse__num--won { color: #2c6e49; }
.pulse__lbl { font-size: 12.5px; color: #756f64; margin-top: 6px; }
.pulse__delta { font-size: 11.5px; color: #a39a8c; margin-top: 4px; }
.pulse__delta--up { color: #2c6e49; }
.pulse__delta--down { color: #b52118; }
</style>
